module.exports = __webpack_public_path__ + "static/media/dsr_trainer2.89bd3369.svg";